import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IwsUpload from '@comp/upload/IwsUpload';
import { httpAction, getAction } from '@/api/manage';
export default {
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      userName: '',
      disableSubmit: false,
      checkList: [],
      values: [],
      tagList: [],
      status: '1',
      visible: true,
      siteName: '',
      user: '',
      columns: [{
        title: '因子名称',
        dataIndex: 'title',
        align: 'center',
        width: '25%' // width: 200,
        // customRender: (text, record, index) => {
        // 	// return this.renderAction(record)
        // }

      }, {
        title: '因子编码',
        align: 'center',
        // width: 150,
        dataIndex: 'code',
        colName: 'code',
        width: '18.75%' // customRender: (text, record, index) => {
        // 	// return record.attrs.statusName
        // }

      }, {
        title: '监测值',
        align: 'center',
        width: '18.75%',
        // width: 150,
        dataIndex: 'value',
        colName: 'value' // customRender: (text, record, index) => {
        // 	// return record.attrs.checkTime
        // }

      }, {
        title: '单位',
        align: 'center',
        width: '18.75%',
        // width: 150,
        dataIndex: 'unitName',
        colName: 'unitName' // customRender: (text, record, index) => {
        // 	// return record.attrs.userName
        // }

      }, {
        title: '备注',
        align: 'center',
        width: '18.75%',
        // width: 150,
        dataIndex: 'remark',
        colName: 'remark' // customRender: (text, record, index) => {
        // 	// return record.attrs.userName
        // }

      }],
      nowDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes()
    };
  },
  props: {
    fatorDetail: {
      type: Object,
      default: {}
    },
    dataSources: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    buttonState: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      // this.loadData()
      if (_this.buttonState) {
        _this.loadData();
      } else {
        _this.dataSources.forEach(function (item, index) {
          _this.values.push('');

          _this.tagList.push('');

          _this.checkList.push('');
        });
      }
    });

    if (this.fatorDetail.attrs.siteName) {
      this.siteName = this.fatorDetail.attrs.siteName;
    } else {
      this.siteName = window.sessionStorage.getItem('siteName'); // this.user = this.$store.state.user.realname

      window.addEventListener('setItem', function (e) {
        if (e.key == 'siteName') {
          _this.siteName = window.sessionStorage.getItem('siteName');
        }
      });
    }
  },
  methods: {
    handleCancel: function handleCancel() {
      this.visible = false;
      this.$emit('close', false);
    },
    submitTable: function submitTable() {
      var _this2 = this;

      if (!this.buttonState) {
        var that = this;
        var param = {};
        param.msgId = this.fatorDetail.attrs.msgId;
        var arr = [];
        var state = false;
        this.dataSources.forEach(function (item, index) {
          var obj = {};
          obj.factorCode = item.code;
          obj.valid = _this2.checkList[index];
          if (obj.valid != '' && !_this2.tagList[index]) state = true;
          obj.factorFlag = _this2.tagList[index];
          obj.remark = _this2.values[index];
          _this2.$refs['iwsupload' + index] ? obj = _this2.$refs['iwsupload' + index].getUploadListToFromData(obj) : '';
          arr.push(obj);
        });

        if (state) {
          this.$message.error('请选择数据标记');
          return;
        }

        param.cmdCheckFlagVoList = arr;
        console.log('param', param);
        httpAction('/online/cmd/check', param, 'post').then(function (res) {
          if (res.success) {
            that.$notification.success({
              message: '操作成功!'
            });
          } else {
            that.$notification.success({
              message: '操作失败!'
            });
          }
        }).finally(function () {
          // this.loadData()
          _this2.$emit('refresh');

          _this2.handleCancel();
        });
      } else {
        this.handleCancel();
      }
    },
    loadData: function loadData() {
      var _this3 = this;

      getAction("/online/cmd/check/".concat(this.fatorDetail.attrs.msgId), '').then(function (res) {
        if (res.success) {
          var data = JSON.parse(JSON.stringify(_this3.dataSources));
          _this3.dataSources = [];
          _this3.userName = res.result.userName;
          _this3.checkTime = res.result.checkTime;
          data.forEach(function (item1, index1) {
            res.result.cmdCheckFlagVoList.forEach(function (item, index) {
              if (item1.code == item.factorCode) {
                item1.dataId = item.id;
                item1.value = item.factorValue;
                item1.remark = item.factorFlagText;

                _this3.dataSources.push(item1);
              }
            });
          });
          res.result.cmdCheckFlagVoList.forEach(function (item, index) {
            _this3.values.push(item.remark);

            _this3.tagList.push(item.factorFlag);

            _this3.checkList.push(item.valid);

            console.log('this.checkList', _this3.checkList);
          });
        } else {
          _this3.dataSources = [];
        }
      });
    }
  }
};